var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notfound"},[_c('a-result',{staticClass:"notfound__result",attrs:{"status":"404","title":"404","sub-title":_vm.message}},[_c('Button',{attrs:{"type":"primary"},on:{"click":_vm.goToHome}},[_vm._v("Home")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }